function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12C2 6.485 6.486 2 12 2C17.514 2 22 6.485 22 12C22 17.514 17.514 22 12 22C8.873 22 5.983 20.577 4.073 18.098C3.828 17.779 3.887 17.322 4.206 17.078C4.523 16.832 4.979 16.893 5.225 17.21C6.858 19.33 9.327 20.546 12 20.546C16.712 20.546 20.546 16.713 20.546 12C20.546 7.288 16.712 3.454 12 3.454C7.288 3.454 3.454 7.288 3.454 12C3.454 12.438 3.487 12.873 3.552 13.299C3.612 13.695 3.34 14.066 2.943 14.127C2.544 14.193 2.175 13.916 2.115 13.519C2.039 13.021 2 12.51 2 12ZM12 7.4541C11.586 7.4541 11.25 7.7901 11.25 8.2041V12.6241C11.25 13.0381 11.586 13.3741 12 13.3741C12.414 13.3741 12.75 13.0381 12.75 12.6241V8.2041C12.75 7.7901 12.414 7.4541 12 7.4541ZM12.0102 15.0459H12.0002C11.5862 15.0459 11.2552 15.3819 11.2552 15.7959C11.2552 16.2099 11.5962 16.5459 12.0102 16.5459C12.4242 16.5459 12.7602 16.2099 12.7602 15.7959C12.7602 15.3819 12.4242 15.0459 12.0102 15.0459Z",
  fill: "currentColor"
});

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.5d7313ee.svg";
export { ForwardRef as ReactComponent };